import React, { useState, useRef,useEffect } from 'react';
import "./Sec3GCC.css";
import Img from '../../Images/Redifining_india.png';
import '../../App.css';
import Popup from 'reactjs-popup';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'; // Import Axios
import Cookies from 'js-cookie';


function Sec3GCC() {

  const [isDownloadPopupOpen, setDownloadPopupIsOpen] = useState(false);
  const [step, setStep] = useState("email"); // email | otp | details | prefilled
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(300); // seconds countdown
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [otpExpired, setOtpExpired] = useState(false);
  const otpInputRef = useRef(null);
  const [sendOtpDisabled, setSendOtpDisabled] = useState(false);
  const [otpCooldown, setOtpCooldown] = useState(0);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [userDetails, setUserDetails] = useState({
    fullName: "",
    companyName: "",
    jobTitle: "",
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState({});

  //const navigate = useNavigate();

  const openDownloadPopupPopup = () => {
    setDownloadPopupIsOpen(true);
  }

  const closeDownloadPopup = () => {
    setDownloadPopupIsOpen(false);
    // Reset state when closing
    setStep("email");
    setEmail("");
    setOtp("");
    setUserDetails({ fullName: "", companyName: "", jobTitle: "" });
    setErrors({});
    setSuccess({});
    setOtpExpired(false);
    setIsTimerActive(false);
    setTimer(300);
  }

  const downloadRef = useRef(null);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    companyName: '',
    jobTitle: ''
  });

  const freeemailBlockedRegex = /\b(gmail|yahoo|outlook|hotmail|live|rediff|rediffmail|msn|aol|inbox|gmx|me|icloud|aim|orange|rocketmail)\.+\b/mi;
  const emailBlockedRegex = /\b(ey|bcg|bain|mckinsey|gartner|kpmg|deloitte|ansr|everestgrp|forrester|pwc|alumni|kearney|idc|marketsandmarkets|infinitiresearch|evalueserve|avasant|monitordeloitte|isg-one|bah|grailinsights|statxo|wiz-matic|accenture|fticonsulting|iney|avalonglobalresearch|ansrglobal|ernstandyoung|talent500|summit|mercer|nexdigm|apexgcc|aeriestechnology|thbs|parthenoney|researchfox|xpheno)\.+\b/gmi;

  useEffect(() => {
    if (success.successMsg) {
      const timer = setTimeout(() => {
        setSuccess((prev) => ({ ...prev, successMsg: "" }));
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [success.successMsg]);

  useEffect(() => {
    let interval = null;
    if (isTimerActive && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(interval);
            setIsTimerActive(false);
            setOtpExpired(true);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isTimerActive, timer]);

  useEffect(() => {
    const checkCookie = async () => {
      try {
        const res = await fetch(
          "https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/get-user-cookie.php",
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
          }
        );
        const json = await res.json();

        if (json.status === "success") {
          const data = json.data;
          setEmail(data.email || "");
          setUserDetails({
            fullName: `${data.first_name ?? ""} ${data.last_name ?? ""}`.trim(),
            companyName: data.company_name || "",
            jobTitle: data.designation || "",
          });
          setStep("prefilled");
        } else {
          setStep("email");
        }
      } catch (err) {
        setStep("email");
      }
    };

    if (isDownloadPopupOpen) {
      checkCookie();
    }
  }, [isDownloadPopupOpen]);

  useEffect(() => {
    let cooldownInterval;
    if (sendOtpDisabled && otpCooldown > 0) {
      cooldownInterval = setInterval(() => {
        setOtpCooldown((prev) => {
          if (prev <= 1) {
            clearInterval(cooldownInterval);
            setSendOtpDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(cooldownInterval);
  }, [sendOtpDisabled, otpCooldown]);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      setErrors((prev) => ({ ...prev, email: "Business Email is required" }));
      return false;
    }
    if (!regex.test(email)) {
      setErrors((prev) => ({ ...prev, email: "Invalid Email" }));
      return false;
    }
    if (freeemailBlockedRegex.test(email) || emailBlockedRegex.test(email)) {
      setErrors((prev) => ({ ...prev, email: "Please enter Business Email" }));
      return false;
    }
    return true;
  };

  const handleSendOtp = async () => {
    if (sendOtpDisabled || sendingOtp) return;

    setErrors({});
    setSuccess({});
    setSendingOtp(true);

    if (!validateEmail(email)) {
      setSendingOtp(false);
      return;
    }

    try {
      const res = await fetch(
        "https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/send-otp.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const text = await res.text();
      const data = JSON.parse(text);

      if (data.success) {
        setSuccess((prev) => ({ ...prev, successMsg: `OTP sent to ${email}` }));
        setStep("otp");
        setOtp("");
        setTimer(300);
        setOtpExpired(false);
        setIsTimerActive(true);
        setSendOtpDisabled(true);
        setOtpCooldown(300);

        setTimeout(() => {
          if (otpInputRef.current) otpInputRef.current.focus();
        }, 100);
      } else {
        setErrors((prev) => ({ ...prev, general: data.message }));
      }
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        general: "Server error while sending OTP",
      }));
    } finally {
      setSendingOtp(false);
    }
  };

  const handleVerifyOtp = async () => {
    setErrors({});
    setSuccess({});

    if (otpExpired) {
      setErrors((prev) => ({
        ...prev,
        otp: "OTP expired. Please request a new one.",
      }));
      return;
    }
    try {
      const res = await fetch(
        "https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/verify-otp.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, otp }),
        }
      );

      const raw = await res.text();
      let data;
      try {
        data = JSON.parse(raw);
      } catch (err) {
        return;
      }

      if (data.success) {
        if (data?.userData) {
          const user = data.userData;
          setEmail(user.email || "");
          setUserDetails({
            fullName: `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim(),
            companyName: user.company_name || "",
            jobTitle: user.designation || "",
          });
          setStep("prefilled");
        } else {
          setStep("details");
        }
      } else {
        setErrors((prev) => ({ ...prev, general: data.message }));
      }
    } catch (error) {
      alert("Server error while verifying OTP");
    }
  };

  const handleDownloadChange = (e) => {
    const { name, value } = e.target;
    setUserDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const errors = {};
    if (!userDetails.fullName.trim()) {
      errors.fullName = "Full Name is required";
    }
    if (!userDetails.companyName.trim()) {
      errors.companyName = "Company Name is required";
    }
    if (!userDetails.jobTitle.trim()) {
      errors.jobTitle = "Job Title is required";
    }
    return errors;
  };

  const getCookieValue = (name) => {
    const cookieStr = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));
    return cookieStr ? decodeURIComponent(cookieStr.split("=")[1]) : null;
  };

  const handleDownloadSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    const searchParams = new URLSearchParams(window.location.search);
    const utm = (key) => searchParams.get(key) || "na";
    const hubspotutkCookie = Cookies.get("hubspotutk");

    if (Object.keys(validationErrors).length === 0) {
      const fullName = userDetails.fullName;
      const [firstName, ...lastParts] = userDetails.fullName.split(" ");
      const lastName = lastParts.join(" ");
      const companyName = userDetails.companyName;
      const jobTitle = userDetails.jobTitle;

      const data = {
        submittedAt: Date.now(),
        fields: [
          { objectTypeId: "0-1", name: "firstname", value: firstName },
          ...(lastName ? [{ objectTypeId: "0-1", name: "lastname", value: lastName }] : []),
          { objectTypeId: "0-1", name: "email", value: email },
          { objectTypeId: "0-1", name: "company", value: companyName },
          { objectTypeId: "0-1", name: "jobtitle", value: jobTitle },
          { objectTypeId: "0-1", name: "page_url", value: window.location.href },
          { objectTypeId: "0-1", name: "report_pdf_link", value: "https://media.zinnov.com/wp-content/uploads/2026/05/zinnov-nasscom-india-gcc-landscape-report-2026.pdf" },
          { objectTypeId: "0-1", name: "report_name", value: "Zinnov Gcc 4 0 Report" },
          { objectTypeId: "0-1", name: "report_title", value: "Zinnov Gcc 4 0 Report" },
          { objectTypeId: "0-1", name: "insight_title", value: "Gcc 4.0 - India Redefining The Globalization Blueprint" },
          { objectTypeId: "0-1", name: "utm_campaign", value: utm("utm_campaign") },
          { objectTypeId: "0-1", name: "utm_content", value: utm("utm_content") },
          { objectTypeId: "0-1", name: "utm_medium", value: utm("utm_medium") },
          { objectTypeId: "0-1", name: "utm_source", value: utm("utm_source") },
          { objectTypeId: "0-1", name: "utm_term", value: utm("utm_term") },
        ],
        context: {
          hutk: hubspotutkCookie,
          pageUri: window.location.href,
          pageName: document.title,
        },
      };

      try {
        const res = await fetch(
          "https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/save-user.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email,
              firstName,
              lastName,
              companyName,
              jobTitle,
            }),
          }
        );
        const text = await res.text();
        const resData = JSON.parse(text);

        if (resData.success) {
          const existingCookie = getCookieValue("ZURD");
          if (!existingCookie) {
            const cookieRes = await fetch(
              "https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/get-user-cookie.php",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                  userRandomid: resData.user_id,
                  email: email,
                  fullName: fullName,
                  companyName: companyName,
                  jobTitle: jobTitle,
                }),
              }
            );

            const cookieData = await cookieRes.json();
            if (!cookieData.success) {
              // Cookie setting failed, but continue with download
            }
          }

          // Fetch CSRF token first
          try {
            const csrfRes = await fetch("https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/csrf-token.php", {
              method: "GET",
              credentials: "include",
              headers: { "Content-Type": "application/json" },
            });
            const csrfData = await csrfRes.json();
            
            if (csrfData.success && csrfData.csrfToken) {
              // Add CSRF token to the data
              data.csrfToken = csrfData.csrfToken;
              
              axios
                .post(
                  "https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/download_report.php",
                  JSON.stringify(data),
                  {
                    withCredentials: true, // Important: send cookies/session
                    headers: {
                      "Content-Type": "application/json",
                      "X-CSRF-Token": csrfData.csrfToken,
                    },
                  }
                )
                .then((response) => {
                  if (response.data.status_code === 400 && response.data.message === "Invalid Email") {
                    alert("Invalid Email");
                  } else {
                    localStorage.setItem(
                      "report_pdf_link",
                      "https://media.zinnov.com/wp-content/uploads/2026/05/zinnov-nasscom-india-gcc-landscape-report-2026.pdf"
                    );
                    window.location.href =
                      "https://zinnov.com/strategy-and-ops-gcc-4-0-india-redefining-the-globalization-blueprint-report-thank-you/?report=zinnov_gcc_4.0_report.pdf";
                  }
                })
                .catch((error) => {
                  alert("Error downloading report. Please try again.");
                });
            } else {
              alert("Failed to get security token. Please refresh and try again.");
            }
          } catch (csrfError) {
            alert("Error getting security token. Please try again.");
          }
        } else {
          alert("Failed to save user details");
        }
      } catch (error) {
        alert("Server error while saving user details");
      }
    } else {
      setErrors(validationErrors);
    }
  };


  return (
    <div className="sec3-gcc-container">
      <div className='sec3-gcc-sub-container'>
        <div className="image-container">
          <img src={Img} alt="India Redefining the Globalization Blueprint" className="image" />
        </div>
        <div className="content-container">
          <h3 className="content-container-title">GCC Landscape 2026 Report</h3>
          <a className="content-container-download-button" href="javascript:void(0);" onClick={openDownloadPopupPopup}>Download Now</a>
        </div>
      </div>
      <Popup className='common-popup-container' open={isDownloadPopupOpen} closeOnDocumentClick onClose={closeDownloadPopup}>
        <div>
          <img id="common-popup-close-button" className="common-popup-close" src="https://zinnov.com/wp-content/themes/zinnov/assets/icons/close.svg" alt="close button" onClick={closeDownloadPopup} />
          <form ref={downloadRef} name="downloadform" id="downloadform" className="contactform" onSubmit={handleDownloadSubmit}>
            {(step === "email" || step === "prefilled") && (
              <div>
                {errors.general && <span className="input-error">{errors.general}</span>}
                {success.successMsg && <span className="input-success">{success.successMsg}</span>}
                <div className="grid full">
                  <div className="common-popup-input-error-container">
                    <input
                      type="email"
                      placeholder="Business Email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="common-popup-input"
                      readOnly={step === "prefilled"}
                    />
                    {errors.email && <span className="input-error">{errors.email}</span>}
                  </div>
                </div>

                {step === "email" && (
                  <div className="grid full mt-20">
                    <div className="submit-blk">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          handleSendOtp();
                        }}
                        className="common-popup-submit"
                        disabled={sendOtpDisabled || sendingOtp}
                      >
                        {sendingOtp ? (
                          <>
                            <span className="spinner" /> Sending...
                          </>
                        ) : sendOtpDisabled ? (
                          `Please wait (${otpCooldown}s)`
                        ) : (
                          "Send OTP"
                        )}
                      </button>
                    </div>
                  </div>
                )}

                {step === "prefilled" && (
                  <div>
                    <div className="grid full">
                      <div className="common-popup-input-error-container">
                        <input
                          type="text"
                          className="common-popup-input"
                          placeholder="Full Name"
                          name="fullName"
                          value={userDetails.fullName}
                          onChange={handleDownloadChange}
                        />
                        {errors.fullName && <span className="input-error">{errors.fullName}</span>}
                      </div>
                      <div className="common-popup-input-error-container">
                        <input
                          type="text"
                          className="common-popup-input"
                          placeholder="Company Name"
                          name="companyName"
                          value={userDetails.companyName}
                          onChange={handleDownloadChange}
                        />
                        {errors.companyName && <span className="input-error">{errors.companyName}</span>}
                      </div>
                      <div className="common-popup-input-error-container">
                        <input
                          type="text"
                          className="common-popup-input"
                          placeholder="Job Title"
                          name="jobTitle"
                          value={userDetails.jobTitle}
                          onChange={handleDownloadChange}
                        />
                        {errors.jobTitle && <span className="input-error">{errors.jobTitle}</span>}
                      </div>
                    </div>
                    <div className="grid full mt-20">
                      <div className="submit-blk">
                        <input type="submit" value="DOWNLOAD" className="common-popup-submit" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {step === "otp" && (
              <div>
                {errors.general && <span className="input-error">{errors.general}</span>}
                {success.successMsg && <span className="input-success">{success.successMsg}</span>}
                <div className="grid full">
                  <div className="common-popup-input-error-container">
                    <input
                      type="text"
                      name="otp"
                      placeholder="Enter OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      ref={otpInputRef}
                      className="common-popup-input"
                      disabled={otpExpired}
                    />
                    {errors.otp && <span className="input-error">{errors.otp}</span>}
                  </div>
                </div>
                <div className="grid full mt-20">
                  <div className="submit-blk otpInlineButton">
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        handleVerifyOtp();
                      }}
                      className={`common-popup-submit ${otpExpired ? "report-common-popup-disabled" : ""}`}
                      disabled={otpExpired}
                    >
                      {otpExpired ? "OTP Expired" : `Verify OTP (${timer}s)`}
                    </button>
                    {otpExpired && (
                      <button
                        type="button"
                        onClick={handleSendOtp}
                        className="common-popup-submit"
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}

            {step === "details" && (
              <div>
                {errors.general && <span className="input-error">{errors.general}</span>}
                <div className="grid full">
                  <div className="common-popup-input-error-container">
                    <input
                      type="text"
                      className="common-popup-input"
                      placeholder="Full Name"
                      name="fullName"
                      value={userDetails.fullName}
                      onChange={handleDownloadChange}
                    />
                    {errors.fullName && <span className="input-error">{errors.fullName}</span>}
                  </div>
                  <div className="common-popup-input-error-container">
                    <input
                      type="text"
                      className="common-popup-input"
                      placeholder="Company Name"
                      name="companyName"
                      value={userDetails.companyName}
                      onChange={handleDownloadChange}
                    />
                    {errors.companyName && <span className="input-error">{errors.companyName}</span>}
                  </div>
                  <div className="common-popup-input-error-container">
                    <input
                      type="text"
                      className="common-popup-input"
                      placeholder="Job Title"
                      name="jobTitle"
                      value={userDetails.jobTitle}
                      onChange={handleDownloadChange}
                    />
                    {errors.jobTitle && <span className="input-error">{errors.jobTitle}</span>}
                  </div>
                </div>
                <div className="grid full mt-20">
                  <div className="submit-blk">
                    <input type="submit" value="DOWNLOAD" className="common-popup-submit" />
                  </div>
                </div>
              </div>
            )}
          </form>
        </div>
      </Popup>
    </div>
  );
}

export default Sec3GCC;
